/**
 * Video player view modes.
 */
export enum MKViewMode {
    Fullscreen = "fullscreen",
    Inline = "inline",
    PictureInPicture = "pictureinpicture"
}